module.exports = __webpack_public_path__ + "static/media/Checkbox.bebace48.svg";